var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRegistrationOpen)?_c('router-link',{staticClass:"btn btn-secondary btn-outline-primary",attrs:{"to":"/register"}},[_vm._t("default",[_vm._v("Register Today!")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }